import { useParams } from 'react-router-dom';

import { useOrganizationId } from '@/hooks/useSwr';
import { addQueryParams } from '@/utils/add-query-params';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function HubRepoCrumb(props: Partial<BreadcrumbData>) {
  const { repo } = useParams();
  const organizationId = useOrganizationId();
  if (!repo) return null;
  const innerPath =
    props.path === '#' ? '#' : addQueryParams(props.path, { organizationId });
  return <Breadcrumb name={repo} path={innerPath} />;
}
